import React from 'react'
import { Link } from 'react-router-dom'

const AboutArea = () => {
    return (
        <>
            <section className="about-area pb-5 ">
                <div className="container services-details">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-12">
                            <div className="ml-about-img">
                                <img src="assets/img/about-us-section.webp" alt="About Images" width="100%" loading="lazy" />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                            <div className="ml-about-content">
                                <h2>Engaging New Audiences Through Smart Approach</h2>
                                <div className="bar"></div>
                                <p className="text-justify">
                                    Alobha Technologies is an established software and application
                                    development company with advantageous and proven accomplishments
                                    engaged in catering Mobile Apps Development, CMS Development,
                                    Web Development, IT Outsourcing solutions & Digital marketing
                                    Services to globally. We are the best software development
                                    service provider in India. We have successfully conceptualized,
                                    developed and launched many web portals across the diverse
                                    industries. We are continuously investing in the latest
                                    technologies, processes, and technical nerds to help our
                                    customers to achieve their business goals and stay ahead from
                                    competitors. With finite resources and infinite expertise in
                                    Agile methodology that ensures the great fusion of a high level
                                    of customer satisfaction and cost-effective services.
                                </p>
                                <Link to="/certificate" className="btn btn-primary text-capitalize" style={{ fontWeight: "500" }}>Our
                                    Certificates</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default AboutArea